module.exports = __webpack_public_path__ + "img/mapview.554515a6.png";